import { CreateWorldCupGroupScreen } from '../../../../../components/worldcup/CreateWorldCupGroupScreen/CreateWorldCupGroupScreen';

export default function CompetitionGroupCreateScreen() {
  return <CreateWorldCupGroupScreen />;
}
